/**
 * Kartensuche der Kartenliste (/pages/pokemon-suche und …-jp).
 *
 * Herkunft: javascript-Tag-Block in sections/pokemon-kartenliste-suche.liquid,
 * ausgelagert am 02.09.2026 (Vollaudit ARCH-1, Owner-Entscheid
 * docs/decisions.md 2026-09-02 (4)). Grund: Shopify buendelt alle
 * javascript-Tag-Bloecke des Themes in EINE compiled_assets/scripts.js — dieser
 * Block war mit rund 420 Zeilen der groesste darin und wurde auf JEDER Seite
 * mitgeliefert, auf der irgendeine Section einen solchen Block hat, obwohl er
 * nur auf einer einzigen Seite ein Element findet.
 *
 * Eingebunden in layout/theme.liquid mit `defer`, hinter derselben
 * Template-Weiche wie assets/kartenliste.css. Das Timing ist identisch zu
 * vorher: die gebuendelte scripts.js trug ebenfalls `defer` (Kopf des
 * Dokuments), das IIFE lief also auch bisher nach dem Parsen und vor
 * DOMContentLoaded. Einziges Theme-Global ist window.hdk (assets/hdk-util.js:
 * kartenPreis seit 05.10.2026, zahlCH seit 06.10.2026) — kein themeStrings,
 * kein routes. hdk-util.js laedt als erstes Theme-Asset (defer, Dokument-
 * reihenfolge), die Position dieses Skripts dahinter ist damit frei.
 *
 * Beim Bearbeiten beachten: der Feldtrenner SEP ist bewusst die Escape-Form
 * '' und nie ein rohes Byte (verschwand einmal im Editor -> Phantom-
 * Treffer). Kontrakt-Assertion und Region-Weiche: Skill shopify-tcg-theme,
 * Abschnitt «Kartenliste».
 */
/* Kartensuche: laedt den Suchindex lazy (erstes Tippen bzw. ?q=-Aufruf),
   filtert clientseitig ueber vorab normalisierte Heuhaufen (DE + EN + Set-Code,
   diakritikfrei). Ergebnis-Zeilen entstehen via createElement/textContent —
   die Namen aus dem JSON gehen nie durch innerHTML. */
(function () {
  var root = document.querySelector('[data-pksearch]');
  if (!root) return;

  var feld = root.querySelector('.pksearch__field');
  var liste = root.querySelector('[data-pksearch-results]');
  var status = root.querySelector('[data-pksearch-status]');
  var mehr = root.querySelector('[data-pksearch-more]');
  if (!feld || !liste || !status) return;

  var indexUrl = root.dataset.indexUrl || '';
  /* Leer = das Liquid konnte keine Kartenseite aufloesen -> Kacheln rendern
     unverlinkt. Bewusst KEIN geratener Default-Pfad (s. Liquid-Kommentar oben). */
  var kartenBasis = root.dataset.cardBase || '';
  var istEn = root.dataset.en === '1';
  /* Region-Weiche: entscheidet ueber Kontrakt (Feldbedeutung), Sortierung
     (JP = Index-Reihenfolge) und Preiszeile. Siehe Liquid-Kopfkommentar. */
  var istJp = root.dataset.jp === '1';
  var tplCount = root.dataset.tplCount || '__N__';
  /* Singularform fuer genau einen Treffer (ARCH-10) — leer = Weiche aus. */
  var tplCountOne = root.dataset.tplCountOne || '';
  var tplCapped = root.dataset.tplCapped || '__N__';
  var str = function (name) {
    var el = root.querySelector('[data-str-' + name + ']');
    return el ? el.textContent : '';
  };

  var MIN_ZEICHEN = 2;
  /* Treffer werden in 100er-Schritten gerendert («Mehr anzeigen», Variante A
     2026-08-27) — die Trefferliste selbst ist nie gekappt, nur das DOM. */
  var SEITE = 100;
  /* Feldgrenze des Suchraums: nicht tippbares Trennzeichen zwischen den
     Namensfeldern — ohne sie matchen Tokens ueber die Naht («riolu» traefe
     das Feldpaar «…lucario»+«lucario…»). IMMER als \u-Escape schreiben, nie
     als rohes Byte: das unsichtbare Zeichen sieht im Editor wie '' aus und
     hat 2026-08-29 sogar einen Audit-Agenten zu einem Falschbefund verleitet
     (Audit ARCH-9/CQ-1). U+0001 kommt in Kartennamen, Set-Codes und
     Illustrator-Credits nicht vor. */
  var SEP = '\u0001';

  /* Preisformat = window.hdk.kartenPreis (assets/hdk-util.js, unit-getestet):
     Waehrungszeichen als Praefix, Tausender-Apostroph, immer zwei Nachkommastellen.
     Liquid-Zwilling ist snippets/pokemon-preis.liquid (SYNC-Marker karten-preis in
     beiden Dateien, Gate (j) in scripts/theme-gates.js). hdk-util.js laedt als
     erstes Theme-Asset, window.hdk steht also beim Rendern der Treffer. */

  /* Locale-Leitwaehrung wie ueberall in der Kartenliste: DE fuehrt den
     Cardmarket-EUR, /en den TCGplayer-USD — die jeweils andere Waehrung ist
     Rueckfall. Ohne beide gibt es keine Preiszeile. Derselbe Wert ist der
     Sortierschluessel (absteigend). */
  function preisVon(k) {
    var erst = istEn ? k.u : k.e;
    var zweit = istEn ? k.e : k.u;
    if (erst > 0) return { wert: erst, symbol: istEn ? '$' : '€' };
    if (zweit > 0) return { wert: zweit, symbol: istEn ? '€' : '$' };
    return null;
  }

  /* Diakritik-tolerante Normalisierung: "Pokémon" == "pokemon". Die
     Geschlechtszeichen (Nidoran) bleiben erhalten und sind mittippbar.

     Japanisch bleibt dabei heil: NFD zerlegt Dakuten nach U+3099/U+309A, die
     Ersetzung raeumt aber nur U+0300–U+036F ab. Heuhaufen und Eingabe laufen
     ohnehin durch dieselbe Funktion — die Zerlegung ist damit symmetrisch,
     egal in welcher Normalform die Tastatur liefert.

     Apostrophe fallen danach ganz weg (ROB-3, 2026-09-02) \u2014 aus Heuhaufen UND
     Eingabe, also symmetrisch. Der Index fuehrt zwei Formen nebeneinander
     (1'026 Karten mit Apostroph: 1'253x U+0027, 73x U+2019), und die Tastatur
     liefert je nach Geraet eine dritte: iOS ersetzt das gerade Zeichen still
     durch das typografische. Vor der Faltung fand \u00abfarfetch'd\u00bb 17 Karten,
     \u00abfarfetch\u2019d\u00bb 3 und \u00abfarfetchd\u00bb 0 \u2014 drei Schreibweisen desselben Namens,
     drei verschiedene Ergebnisse. Danach finden alle drei dieselben 20.
     Gegenprobe, dass die Faltung nichts zusammenwirft: die Zahl distinkter
     Heuhaufen bleibt bei 19'203, \u00abriolu\u00bb bei 34 Treffern.

     Bewusst KEIN NFKC (ROB-7 bleibt offen): das faltete auch Ligaturen,
     Breiten- und Ziffern-Sonderformen ein und braeuchte einen eigenen Beleg
     ueber den JP-Datenraum. */
  function norm(s) {
    return s
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u2019'\u2018`\u00b4]/g, '');
  }

  /* Kartennummer best-effort aus dem Handle (…-glurak-4-bs -> "4"): vorletztes
     Segment, wenn es mit einer Ziffer beginnt. Promo-/Sonderhandles ohne dieses
     Muster zeigen schlicht keine Nummer. */
  function nummerAusHandle(h) {
    var teile = h.split('-');
    if (teile.length < 3) return '';
    var kandidat = teile[teile.length - 2];
    return /^\d/.test(kandidat) ? kandidat : '';
  }

  var karten = null;      /* [{de,en,h,code,e,u,img,heu}] nach dem Laden */
  var laden = null;       /* Promise-Guard: nur ein Fetch; nach einem Fehler null */

  /* Zwei Fristen statt einer (ROB-16, 2026-10-06), weil der Index gross ist
     (≈ 500 KB br, Slow-4G gemessen 8.6 s, s. Idle-Preload unten):
     - KOPF 15 s bis zu den Antwort-Headern. Das CDN antwortet sonst in
       Sekundenbruchteilen; wer 15 s keinen Header hat, haengt — ohne Frist
       stuende «Suchindex wird geladen …» fuer immer da.
     - GESAMT 90 s fuer den ganzen Download. Eine einzige 15-s-Frist braeche
       jede langsame, aber laufende Verbindung ab (2G mit ~70 kbit/s braucht
       fuer 500 KB rund eine Minute) — und jeder neue Versuch liefe in dieselbe
       Wand. 90 s deckt das noch mit Reserve und faengt trotzdem einen Abriss
       mitten im Body.
     Nach Ablauf bricht AbortController den Fetch ab; der catch-Zweig zeigt
     den bestehenden Fehlertext und setzt `laden` zurueck, die naechste
     Eingabe startet einen neuen Versuch. */
  var FRIST_KOPF_MS = 15000;
  var FRIST_GESAMT_MS = 90000;

  function indexLaden() {
    if (laden) return laden;
    /* Kein Lade-Text hier: indexLaden() laeuft auch als stiller Idle-Preload
       (PERF-5) — den «laedt…»-Text setzen die wartenden Aufrufer selbst. */
    var abbruch = new AbortController();
    var fristKopf = setTimeout(function () { abbruch.abort(); }, FRIST_KOPF_MS);
    var fristGesamt = setTimeout(function () { abbruch.abort(); }, FRIST_GESAMT_MS);
    laden = fetch(indexUrl, { signal: abbruch.signal })
      .then(function (res) {
        clearTimeout(fristKopf);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        clearTimeout(fristGesamt);
        return json;
      })
      .then(function (json) {
        /* Kontrakt-Assertion (TEST-5, 2026-08-29; scharf gestellt 2026-09-02):
           der Index kommt aus einem fremden Repo (Pipeline-Wochenlauf); eine
           stille Spaltenverschiebung wuerde sonst Preise, Namen und Links
           verwuerfeln, ohne dass irgendwo ein Fehler faellt. Geprueft wird auf
           GENAU EINE Version — eine zweite geduldete Fassung waere eine tote
           Toleranz, unter der ein Regress der Pipeline stumm durchginge (das
           war der Befund DEP-2 vom 2026-09-02).

           Kontrakt v4 (int) / v3 (jp), Spez im Pipeline-README §7n: gemeinsame
           CDN-Basis der Kartenscans EINMAL im Kopf (`imgBase`, endet auf '/'),
           Bild-Spalte relativ. Drei Fallen aus der Spez: leere Bild-Zelle NIE
           praefixen; imgBase darf '' sein (dann sind die Zellen schon absolut);
           imgBase IMMER aus dem JSON lesen, nie hartkodieren.

           Bump-Rezept (drei Schritte, je eigener Commit — Pipeline-README §7n):
           (1) hier beide Fassungen akzeptieren, (2) Pipeline deployt,
           (3) Toleranz wieder raus. */
        var vErwartet = istJp ? 3 : 4;
        if (json.v !== vErwartet) {
          throw new Error('Index-Kontrakt v' + json.v + ' statt v' + vErwartet);
        }
        if (typeof json.imgBase !== 'string') {
          throw new Error('Index-Kontrakt v' + vErwartet + ' ohne Kopf-Feld imgBase');
        }
        var imgBase = json.imgBase;
        function bildAbsolut(zelle) {
          /* Leere Zelle heisst «kein Scan» und bleibt leer — mit Praefix zeigte
             die Trefferliste sonst tausendfach dasselbe kaputte Bild. */
          if (!zelle) return '';
          return imgBase + zelle;
        }
        karten = (json.cards || []).map(function (c) {
          /* Zwei Datenraeume, EINE Kachel-Datenform. International (v4):
             [de, en, handle, code, e, u, img, il]. Japanisch (v3): [de, en,
             handle, code, img, jp, il] — andere Bedeutung ab Position 4, darum
             eine explizite Weiche statt einer Laengen-Heuristik. */
          var k = istJp
            ? {
                de: c[0], en: c[1], h: c[2], code: c[3],
                e: 0, u: 0, img: bildAbsolut(c[4]), jp: c[5] || '', il: c[6] || ''
              }
            : {
                de: c[0], en: c[1], h: c[2], code: c[3],
                e: c[4] || 0, u: c[5] || 0, img: bildAbsolut(c[6]), jp: '', il: c[7] || ''
              };
          /* Suchraum: beide Namen + Set-Code + Illustrator, japanisch
             zusaetzlich der JP-Name — «GIDORA» findet alle Karten des
             Zeichners, «リザードン» dieselben Karten wie «Glurak». */
          k.heu = norm(k.de + SEP + k.en + SEP + k.code + SEP + k.jp + SEP + k.il);
          /* Illustrator separat normalisiert: die Kachel zeigt ihn nur, wenn
             die Eingabe IHN getroffen hat — sonst truege fast jede Kachel die
             Zusatzzeile, obwohl der Treffer ueber den Namen kam. */
          k.iln = k.il ? norm(k.il) : '';
          /* Sortierschluessel EINMAL vorrechnen statt im Comparator (Audit
             2026-08-21): preisVon() erzeugte dort zwei Wegwerf-Objekte pro
             Vergleich, also O(n log n) Allokationen je Tastendruck. istEn ist
             zur Laufzeit konstant, der Schluessel damit stabil. Ohne Preis -1:
             preislose Karten fallen ans Ende, dort bleibt die Index-Reihenfolge
             (neueste Sets zuerst) als stabile Zweitordnung.
             Der JP-Zweig sortiert gar nicht (s. unten) und braucht ihn nicht. */
          if (!istJp) {
            var p = preisVon(k);
            k.sp = p ? p.wert : -1;
          }
          return k;
        });
        anwenden();
      })
      .catch(function (fehler) {
        /* Nicht stumm schlucken: ein gebrochener Kontrakt (falsches json.v,
           fehlendes imgBase) sieht auf der Seite wie ein Netzfehler aus — die
           Konsole muss sagen, welcher der beiden es war. */
        clearTimeout(fristKopf);
        clearTimeout(fristGesamt);
        if (window.console && console.error) console.error('[pksearch] Suchindex nicht nutzbar:', fehler);
        laden = null;
        status.textContent = str('error');
      });
    return laden;
  }

  /* Bild-URL mit width-Parameter (Shopify-CDN-Resize) — die Index-URL traegt
     schon einen ?v=-Querystring. */
  function bildUrl(img, breite) {
    return img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=' + breite;
  }

  function kachelBauen(k) {
    var li = document.createElement('li');
    li.className = 'chase-grid__item';
    /* Kachel = geteilte Klassenfamilie .chase-tile (assets/theme.css, mit Set-Seite und
       Produktseite). Ohne Basis-Pfad kein <a> mit geratenem Ziel — dann eine <span>-
       Kachel mit DENSELBEN Klassen: die Suche gab auch der unverlinkten Kachel bisher
       Hover und Transition (.pksearch__tile band nicht an a), das bleibt so. */
    var a = document.createElement(kartenBasis ? 'a' : 'span');
    a.className = 'chase-tile chase-tile--link';
    if (kartenBasis) a.href = kartenBasis + k.h;

    var stage = document.createElement('span');
    stage.className = 'chase-tile__stage';
    if (k.img) {
      var img = document.createElement('img');
      img.className = 'chase-tile__img';
      img.src = bildUrl(k.img, 300);
      img.srcset = bildUrl(k.img, 300) + ' 300w, ' + bildUrl(k.img, 600) + ' 600w';
      img.sizes = '(min-width: 900px) 200px, 44vw';
      img.width = 300;
      img.height = 413;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      stage.appendChild(img);
    } else {
      var plate = document.createElement('span');
      plate.className = 'chase-tile__plate';
      plate.textContent = k.code;
      stage.appendChild(plate);
    }

    var name = document.createElement('span');
    name.className = 'chase-tile__name';
    name.textContent = (istEn && k.en) ? k.en : (k.de || k.en);

    /* Japanischer Originalname als Zweitzeile — im Idiom der .pkset__jpname auf
       der JP-Set-Seite: eine Stufe leiser als der Name, ohne Label. `lang` ist
       Pflicht, damit der Browser den CJK-Font-Stack zieht und Screenreader die
       Zeile japanisch sprechen. */
    var jpEl = null;
    if (k.jp) {
      jpEl = document.createElement('span');
      jpEl.className = 'pksearch__jp';
      jpEl.lang = 'ja';
      jpEl.textContent = k.jp;
    }

    /* Illustrator-Zeile nur bei Illustrator-Treffer (Flag aus anwenden()) —
       sonst truege fast jede Kachel die Zeile, obwohl der Treffer ueber den
       Kartennamen kam. */
    var ilEl = null;
    if (k.zi && k.il) {
      ilEl = document.createElement('span');
      ilEl.className = 'pksearch__il';
      ilEl.textContent = k.il;
    }

    var meta = document.createElement('span');
    meta.className = 'chase-tile__meta';
    var setnum = document.createElement('span');
    setnum.className = 'chase-tile__num';
    var num = nummerAusHandle(k.h);
    setnum.textContent = k.code + (num ? ' #' + num : '');
    meta.appendChild(setnum);
    /* Preiszeile nur im internationalen Zweig — der JP-Index fuehrt keine. */
    if (!istJp) {
      var preis = preisVon(k);
      if (preis) {
        var preisEl = document.createElement('span');
        preisEl.className = 'chase-tile__price';
        preisEl.textContent = window.hdk.kartenPreis(preis.wert, preis.symbol);
        meta.appendChild(preisEl);
      }
    }

    a.appendChild(stage);
    a.appendChild(name);
    if (jpEl) a.appendChild(jpEl);
    if (ilEl) a.appendChild(ilEl);
    a.appendChild(meta);
    li.appendChild(a);
    return li;
  }

  function anwenden() {
    var q = feld.value.trim();
    /* Mindestlaenge auf der NORMALISIERTEN Form (ROB-16, 2026-10-06): norm()
       wirft Apostrophe und Akzente weg — «''» oder «``» hatten roh 2 Zeichen,
       normalisiert 0 Tokens, und eine leere Token-Liste passt auf jede Karte
       (der ganze Index als «Treffer»). Gemessen wird wie die Suche selbst sucht.
       Ergaenzung 2026-10-06 (ROB-16-Rest): die Mindestlaenge gilt fuer das
       LAENGSTE Token, nicht fuer die Gesamtlaenge — «a b» bestand sonst mit 3
       Zeichen und traf 8'183 Karten; Regel und Begruendung in hdk.suchbar. */
    var tokens = norm(q).split(/\s+/).filter(Boolean);
    if (!window.hdk.suchbar(tokens, MIN_ZEICHEN)) {
      liste.textContent = '';
      status.textContent = q === '' ? '' : str('hint');
      if (mehr) mehr.hidden = true;
      /* Pagination-Zustand MIT verwerfen (ROB-2, 2026-08-29): sonst zeigte
         «Mehr anzeigen» die Treffer 101+ einer bereits verworfenen Suche —
         Verteidigung in der Tiefe, unabhaengig von der Sichtbarkeit des Knopfs. */
      aktTreffer = [];
      gezeigt = 0;
      urlSyncen(q);
      return;
    }
    if (!karten) { status.textContent = str('loading'); indexLaden(); return; }

    var treffer = [];
    for (var i = 0; i < karten.length; i++) {
      var k = karten[i];
      var passt = true;
      for (var t = 0; t < tokens.length; t++) {
        if (k.heu.indexOf(tokens[t]) === -1) { passt = false; break; }
      }
      if (!passt) continue;
      /* Illustrator-Treffer-Flag fuer die Kachel: hat MINDESTENS ein Token den
         Zeichner getroffen, zeigt die Kachel seine Zeile. Das Flag haengt an
         der Karte und wird pro Suchlauf neu gesetzt — kein Stale-Zustand. */
      k.zi = false;
      for (var z2 = 0; z2 < tokens.length; z2++) {
        if (k.iln && k.iln.indexOf(tokens[z2]) !== -1) { k.zi = true; break; }
      }
      treffer.push(k);
    }

    /* Preis absteigend (Entscheid Cyrille 2026-08-20): Sortierschluessel =
       angezeigter Locale-Preis; Karten ohne Preis ans Ende, dort bleibt die
       Index-Reihenfolge (neueste Sets zuerst) als stabile Zweitordnung.

       JP kennt keine Preise und wird darum GAR NICHT sortiert: die Treffer
       behalten die Index-Reihenfolge, und die ist die Reihenfolge der
       JP-Uebersicht (neueste Erweiterung zuerst). Eine Sortierung ueber lauter
       -1 waere derselbe Effekt bei zusaetzlicher Arbeit — und ein stiller
       Fallstrick, sobald jemand den Comparator anfasst. */
    if (!istJp) treffer.sort(function (a, b) { return b.sp - a.sp; });

    aktTreffer = treffer;
    gezeigt = 0;
    liste.textContent = '';
    rendernBis(SEITE);
    urlSyncen(q);
  }

  /* Rendert die Treffer bis zur Zielmarke nach (inkrementell — bereits
     gerenderte Kacheln bleiben stehen, der Scroll auch) und fuehrt Knopf und
     Status nach. Eine Kachel wird nie doppelt gebaut: Start ist `gezeigt`. */
  var aktTreffer = [];
  var gezeigt = 0;
  function rendernBis(ziel) {
    var limit = Math.min(aktTreffer.length, ziel);
    var frag = document.createDocumentFragment();
    for (var z = gezeigt; z < limit; z++) frag.appendChild(kachelBauen(aktTreffer[z]));
    liste.appendChild(frag);
    gezeigt = limit;
    if (mehr) mehr.hidden = gezeigt >= aktTreffer.length;

    if (aktTreffer.length === 0) {
      status.textContent = str('none');
    } else if (gezeigt < aktTreffer.length) {
      /* Zahlen im Schweizer Satz (ROB-16, 2026-10-06): «100 von 21'234» statt
         «21234» — dieselbe Regel wie die Hub-Kennzahlen (pokemon-zahl.liquid). */
      status.textContent = tplCapped
        .replace('__N__', window.hdk.zahlCH(gezeigt))
        .replace('__TOTAL__', window.hdk.zahlCH(aktTreffer.length));
    } else if (aktTreffer.length === 1 && tplCountOne) {
      status.textContent = tplCountOne;
    } else {
      status.textContent = tplCount.replace('__N__', window.hdk.zahlCH(aktTreffer.length));
    }
  }

  /* Suchbegriff als #q= in der URL nachfuehren (teilbare Links, Zuweg vom
     Uebersichts-Feld und von den Illustrator-Links). Fragment statt Query seit
     2026-10-04 (Audit SEO-025, Owner-Frage 20): Shopify uebernahm ?q= in den
     canonical_url der Seite und cachte das HTML ohne q — eine fremde Anfrage
     wurde zum Canonical fuer alle. Das Fragment erreicht den Server nie. Ein
     altes ?q= wird beim ersten Sync in #q= umgeschrieben. */
  function urlSyncen(q) {
    var url = new URL(window.location.href);
    url.searchParams.delete('q');
    url.hash = q ? 'q=' + encodeURIComponent(q) : '';
    window.history.replaceState(null, '', url.hash ? url : url.pathname + url.search);
  }
  /* Suchbegriff aus der URL: #q= (neu) vor ?q= (alte Links, Lesezeichen). */
  function urlQuery() {
    var url = new URL(window.location.href);
    var ausHash = new URLSearchParams(url.hash.replace(/^#/, '')).get('q');
    return ausHash || url.searchParams.get('q') || '';
  }

  if (mehr) {
    mehr.addEventListener('click', function () {
      /* Ziel-Verhalten (Cyre 2026-08-30): die Seite bleibt beim Klick exakt
         an Ort und waechst nur um die neuen Kacheln. Zwei Springquellen
         explizit ausgeschaltet: (1) Chromes Scroll-Anchoring haelt sonst den
         geklickten Knopf im Blick und springt um die Hoehe der eingefuegten
         Kacheln nach UNTEN — darum Position sichern und danach
         wiederherstellen. (2) der A11y-Fokus auf die Statuszeile (steht UEBER
         dem Raster) scrollte per focus() nach OBEN — preventScroll. */
      var y = window.scrollY;
      rendernBis(gezeigt + SEITE);
      /* Versteckt dieser Klick den Knopf (alles gerendert), fiele der Fokus
         ans body — stattdessen auf die Statuszeile setzen, die traegt den
         frischen Zaehltext (A11y-Hinweis aus ROB-1). */
      if (mehr.hidden) {
        status.setAttribute('tabindex', '-1');
        status.focus({ preventScroll: true });
      }
      /* Nur die synchrone Wiederherstellung — der frueher hier stehende
         Doppel-rAF-Nachschlag ist am 2026-09-02 gemessen wirkungslos gewesen
         und entfernt (Audit CQ-11).

         Gemessen headless bei 412x823 und 1280x900, je vier Scrollpositionen
         (Knopf knapp unter der Falz bis Knopf am oberen Rand), drei Varianten
         per Request-Interception: wie ausgeliefert / ohne Doppel-rAF / ohne
         jede Wiederherstellung. Alle 24 Messpunkte scrollY-Delta 0.

         Der Messstand war dabei nachweislich empfindlich, sonst hiesse 0 gar
         nichts: auf einer synthetischen Seite verschob dieselbe Chrome-
         Instanz den Scroll um +1'210 px, sobald oberhalb des Ankers eingefuegt
         wurde (mit `overflow-anchor: auto`; mit `none` 0 px). Und der Klick in
         der Messung tat wirklich etwas — 100 Kacheln mehr, Dokument 15'370 px
         hoeher, scrollY unveraendert 15'371.

         Damit ist auch klar, WARUM nichts springt: die neuen Kacheln landen am
         Listenende, also UNTERHALB des Ankers (erste sichtbare Kachel oben im
         Viewport). Chromes Scroll-Anchoring reagiert nur auf Verschiebungen
         oberhalb — die Einfuegung dieses Knopfs kann es strukturell nicht
         ausloesen.

         Diese Zeile und `overflow-anchor: none` in assets/kartenliste.css
         bleiben trotzdem stehen: beide kosten nichts und decken den Fall ab,
         dass hier je wieder oberhalb der Falz gerendert wird. Der Doppel-rAF
         war der einzige der drei Gurte mit laufenden Kosten (zwei erzwungene
         Layout-Flushs pro Klick) und ohne belegbare Wirkung. */
      window.scrollTo(0, y);
    });
  }

  var timer = null;
  feld.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(anwenden, 120);
  });
  feld.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && feld.value !== '') {
      feld.value = '';
      anwenden();
    }
  });

  /* Direktaufruf mit #q= bzw. ?q= (Uebersichts-Suchfeld, Illustrator-Links,
     alte Lesezeichen): Feld fuellen, Index sofort laden, filtern sobald er da
     ist. Ein spaeterer Hash-Wechsel auf derselben Seite (Link mit anderem #q=)
     laedt die Seite nicht neu — darum hashchange. */
  window.addEventListener('hashchange', function () {
    var q = urlQuery();
    if (!q || q === feld.value) return;
    feld.value = q;
    anwenden();
  });
  var start = urlQuery();
  if (start) {
    feld.value = start;
    status.textContent = str('loading');
    indexLaden();
  } else {
    /* Idle-Preload (PERF-5, 2026-08-29): die Seite hat keinen anderen Zweck
       als die Suche — bisher startete der 518-KB-Download erst mit dem ersten
       Tastendruck, der Erst-Treffer wartete gedrosselt ~4 s. Der Promise-Guard
       `laden` verhindert Doppel-Fetches, wenn jemand vor dem Idle-Tick tippt;
       still (kein Statustext), damit die Seite nicht ohne Nutzeraktion
       «laedt…» meldet. */
    /* Ausnahme vom Preload (PERF-9, 2026-09-02): auf ausdruecklich sparsamen
       Verbindungen wird NICHT vorgeladen. Der Index ist 500 KB br (2.6 MB
       roh) und braucht auf Slow-4G gemessen 8.6 s — das ist kein Nebenbei-
       Download, sondern auf einem Datenlimit ein spuerbarer Posten fuer
       jemanden, der die Seite vielleicht nur streift. Wer dann tippt oder das
       Feld fokussiert, loest den Fetch selbst aus; `indexLaden()` haengt am
       Promise-Guard, doppelt laedt hier nichts.

       `navigator.connection` ist Chromium-only — fehlt es (Safari, Firefox),
       bleibt es beim Preload wie bisher. saveData ist die ausdrueckliche
       Nutzerentscheidung («Datensparmodus»), effectiveType die gemessene Lage;
       beides zaehlt. */
    var verb = navigator.connection;
    var sparsam = !!verb && (verb.saveData === true ||
      verb.effectiveType === 'slow-2g' || verb.effectiveType === '2g');

    if (sparsam) {
      /* `once`: der Fetch soll genau einmal starten, nicht bei jedem Fokus. */
      feld.addEventListener('focus', function () { indexLaden(); }, { once: true });
    } else {
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 800); };
      idle(function () { indexLaden(); });
    }
  }
})();
